const onResizeCallbacks = [];

const mobile = Symbol('mobile');
const verticalTablet = Symbol('verticalTablet');
const desktop = Symbol('desktop');

let currentAdaptive = desktop; // т.к. верстка изначально под десктоп

$('.section-tabs').each(function eachSection(sectionIndex, Section) {
    const $section = $(Section);

    const $tabs = $section.find('.tabs');
    const $namesContainers = $tabs.find('.tabs__item');
    const $names = $namesContainers.find('.block-title');

    const $contentsContainer = $section.find('.tabs-content');
    const $contents = $contentsContainer.children('.tab-content');

    onResizeCallbacks.push(onResize);

    function onResize() {
        if (mobile === currentAdaptive) {
            $contents.each(function eachContentColumn(contentIndex, Content) {
                const nameIndex = contentIndex;

                $(Content).prepend($names[nameIndex]);
            });
        }

        else if (verticalTablet === currentAdaptive || desktop === currentAdaptive) {
            $namesContainers.each(function eachTitleColumn(contentIndex, Content) {
                const nameIndex = contentIndex;

                $(Content).prepend($names[nameIndex]);
            });
        }
    }
});

$(window).on('resize', onResize);

onResize();

function onResize() {
    let adaptive;

    if (innerWidth < NLMK.mediaQueries.verticalTablet.min) {
        adaptive = mobile;
    }

    else if (innerWidth < NLMK.mediaQueries.horizontalTablet.min) {
        adaptive = verticalTablet;
    }

    else {
        adaptive = desktop;
    }

    if (currentAdaptive !== adaptive) {
        currentAdaptive = adaptive;

        onResizeCallbacks.forEach(callback => callback());
    }
}



// WEBPACK FOOTER //
// ./js/main/module/section-tabs.js